<app-programtitle title="Palindrome"></app-programtitle>
<p> Write a program to check if a string is Palindrome or not. Palindrome is a string that reads same backward and forward. For E.g, Dad, Mum, Madam, 1881, Malayalam etc. </p>

<app-editor code="{{program}}"> </app-editor>